import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import {
  DiscountMessageBoxWidget,
  WidgetTypeType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setSelectedWidgetVariantSettings,
} from "../../../store/slices/widgets";
import { IconGrid, IconGridItems } from "../WidgetVariants/IconGrid";
import { DiscountMessageBoxPopupWidget1 } from "../WidgetVariants/Icons/DiscountMessageBoxPopupWidget1";
import { DiscountMessageBoxPopupWidget2 } from "../WidgetVariants/Icons/DiscountMessageBoxPopupWidget2";
import { DiscountMessageBoxSlideOutWidget1 } from "../WidgetVariants/Icons/DiscountMessageBoxSlideoutWidget1";
import { DiscountMessageBoxSlideOutWidget2 } from "../WidgetVariants/Icons/DiscountMessageBoxSlideoutWidget2";

interface MessageBoxSettingsProps {
  widgetType: WidgetTypeType;
  configType: "mobile" | "desktop";
}

export const DiscountMessageBoxVariantSettings = ({
  widgetType,
  configType,
}: MessageBoxSettingsProps) => {
  const messageBoxWidget = useSelector(
    selectedWidget
  ) as DiscountMessageBoxWidget;
  const dispatch = useDispatch();

  const items = useMemo<IconGridItems>(() => {
    if (widgetType === "messageBoxPopup") {
      return [
        [
          {
            icon: <DiscountMessageBoxPopupWidget1 />,
            key: "messageBoxPopupWidget1",
            checked:
              messageBoxWidget?.config[configType]?.variant ===
              "messageBoxPopupWidget1",
          },
        ],
        [
          {
            icon: <DiscountMessageBoxPopupWidget2 />,
            key: "messageBoxPopupWidget2",
            checked:
              messageBoxWidget?.config[configType]?.variant ===
              "messageBoxPopupWidget2",
          },
        ],
      ];
    } else {
      return [
        [
          {
            icon: <DiscountMessageBoxSlideOutWidget1 />,
            key: "messageBoxSlideOutWidget1",
            checked:
              messageBoxWidget?.config[configType]?.variant ===
              "messageBoxSlideOutWidget1",
          },
        ],
        [
          {
            icon: <DiscountMessageBoxSlideOutWidget2 />,
            key: "messageBoxSlideOutWidget2",
            checked:
              messageBoxWidget?.config[configType]?.variant ===
              "messageBoxSlideOutWidget2",
          },
        ],
      ];
    }
  }, [messageBoxWidget, widgetType]);

  const onIconClick = (key: string) => {
    dispatch(setSelectedWidgetVariantSettings({ key, configType }));
  };

  return (
    <Grid container item direction={"column"} columnSpacing={2} rowSpacing={4}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
          Message Box Styles
        </IgTypography>
      </Grid>
      <Grid container item>
        <IconGrid
          gridKey={`message-box-widget-${widgetType}`}
          items={items}
          onClick={onIconClick}
        />
      </Grid>
    </Grid>
  );
};
